<!-- eslint-disable max-len -->
<template>
  <li class="nav-item dropdown active" ref="parent">
    <a
      class="nav-link dropdown-toggle"
      href="#"
      id="saveStatesMenu"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      @click="shouldDisplayDropdown = !shouldDisplayDropdown"
      aria-expanded="false">
      save states
    </a>
    <div ref="dropdown" :class="'dropdown-menu navbar-bg ' + (shouldDisplayDropdown ? 'show' : '')" aria-labelledby="saveStatesMenu">
      <div class="env-dropdown-content">
      <div v-if="loading">
        Loading...
      </div>
      <div v-else>
        <div v-if="noGroupLoaded">
          No group loaded
        </div>
        <div v-else>
          <div class="state-list-item" v-for="(state, idx) of saveStates" :key="idx">
            <span class="state-list-item-text">{{state.name}}</span> <b-btn @click="clickLoad(state)" class="icon-btn">load</b-btn> <b-btn @click="clickDelete(state)" class="icon-btn">delete</b-btn>
          </div>
          <b-input-group>
            <b-input v-model="stateName" placeholder="New State Name"></b-input>
            <b-input-group-append>
              <b-btn :disabled="!stateName || stateName.length === 0" @click="clickCreateSaveState">Save</b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </div>
    </div>
  </li>
  <!-- old version, switch this back on to add it to other places
  <b-dropdown id="env-dropdown" text="Active Asset Environments" style="margin-top: 2px; width: 200px;">
    <div class="env-dropdown-content">
      <b-form-group label="">
        <b-checkbox-group v-model="selected" :options="options" @change="onEnabledChanged">
        </b-checkbox-group>
      </b-form-group>
    </div>
  </b-dropdown>
  -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  async mounted() {
    await this.refresh();
  },

  data() {
    return {
      stateName: '',
      shouldDisplayDropdown: false,
      noGroupLoaded: false,
      error: null,
      loading: false,
      saveStates: []
    };
  },
  computed: {
    ...mapGetters([
      'group'
    ]),

    options() {
      return this.getAssetEnvironments;
    }
  },
  methods: {
    ...mapActions([
      'getSaveStates',
      'createSaveState',
      'restoreSaveState',
      'deleteSaveState',
    ]),
    async clickLoad(state) {
      try {
        await this.restoreSaveState({ groupId: this.group._id, saveName: state.name });
        this.$router.go(0);
      } catch (err) {
        if (err.response) {
          // eslint-disable-next-line no-alert
          alert(`Failed to load save state: ${err.response.data}`);
        } else {
          // eslint-disable-next-line no-alert
          alert(`Failed to load save state: ${err}`);
        }
      }
    },

    async clickDelete(state) {
      try {
        await this.deleteSaveState({ groupId: this.group._id, saveName: state.name });
        this.$router.go(0);
      } catch (err) {
        if (err.response) {
          // eslint-disable-next-line no-alert
          alert(`Failed to delete save state: ${err.response.data}`);
        } else {
          // eslint-disable-next-line no-alert
          alert(`Failed to delete save state: ${err}`);
        }
      }
    },

    async clickCreateSaveState() {
      try {
        await this.createSaveState({ groupId: this.group._id, saveName: this.stateName });
        this.$router.go(0);
      } catch (err) {
        if (err.response) {
          // eslint-disable-next-line no-alert
          alert(`Failed to create save state: ${err.response.data}`);
        } else {
          // eslint-disable-next-line no-alert
          alert(`Failed to create save state: ${err}`);
        }
      }
    },
    async refresh() {
      this.noGroupLoaded = false;
      this.loading = true;
      this.saveStates.length = 0;
      try {
        if (this.group && this.group._id) {
          const { saveStates } = await this.getSaveStates({ groupId: this.group._id });
          console.log(saveStates);
          for (let i = 0; i < saveStates.length; i++) {
            console.log(`trying ${i}`);
            this.saveStates.push(saveStates[i]);
          }
        } else {
          this.noGroupLoaded = true;
        }
      } catch (ex) {
        console.error(ex);
        this.$set(this, 'error', 'Failed to load asset environments.  Please try again later.  If the issue persists, please notify the developers.');
      }

      this.loading = false;
    }
  },
  watch: {
    group(newValue, oldValue) {
      if (newValue._id !== oldValue._id) {
        console.log('group updated');
        this.refresh();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.env-dropdown-content
{
  color: white;
  padding: 10px;
  width: 350px;
  max-height: 500px;
  overflow-y: auto;
}

header {
  height: 40px;
}
.navbar-root {
  height: 100%;
  padding-top: 4px;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }
}

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  width: 50%;
  height: 100%;
  position: relative;
}
.logo-link {
  outline-color: white;
  height: 100%;
  margin-left: 10px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  height: 100%;
  margin: auto;
  margin-top: -2px;
  text-align: center;
  white-space: nowrap;
  font-size: 16pt;
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
}
.navbar-actionItems {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}
.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}

.state-list-item {
  display: flex;
  margin-bottom: 10px;
  padding: 5px;
  //border: 1px solid rgba(255,255,255,0.3);
  background-color: rgba(17,17,17,0.8);
}

.state-list-item-text
{
  flex-basis: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/SaveStateSelector.vue